<!-- ▼ ▼ ▼ 差分強調表示用テンプレート(金額) ▼ ▼ ▼ -->
<ng-template #emphPrice let-content>
  <span [ngClass]="{ del: content?.type === 'del', diff: content?.type === 'diff' }">
    <span *ngIf="content?.value" [innerHTML]="content?.value | amountFormat : undefined : currencyCode"></span>
    <span *ngIf="!content?.value" [innerHTML]="'label.hyphen' | staticMsg"></span>
    <span
      *ngIf="content?.type === 'del' || content?.type === 'diff'"
      class="u-visually-hidden"
      [innerHTML]="'reader.diffIcon' | staticMsg"
    ></span>
    <span
      *ngIf="content?.type === 'del'"
      class="u-visually-hidden"
      [innerHTML]="'reader.revokedService' | staticMsg"
    ></span>
  </span>
</ng-template>

<!-- ▼ ▼ ▼ 差分強調表示用テンプレート(翻訳) ▼ ▼ ▼ -->
<ng-template #emphTr let-content>
  <span [ngClass]="{ del: content?.type === 'del', diff: content?.type === 'diff' }">
    <span *ngIf="content?.value" [innerHTML]="content?.value | staticMsg"></span>
    <span *ngIf="!content?.value" [innerHTML]="'label.hyphen' | staticMsg"></span>
    <span
      *ngIf="content?.type === 'del' || content?.type === 'diff'"
      class="u-visually-hidden"
      [innerHTML]="'reader.diffIcon' | staticMsg"
    ></span>
    <span
      *ngIf="content?.type === 'del'"
      class="u-visually-hidden"
      [innerHTML]="'reader.revokedService' | staticMsg"
    ></span>
  </span>
</ng-template>

<!-- 以下、本体 -->

<div id="anc-baggage" class="p-manage-booking__item" [ngClass]="{ 'grey-bg': !isPlanValid, 'is-scroll': isScroll }">
  <div class="p-plan-table js-plan-table01-item" [ngClass]="{ 'grey-bg': !isPlanValid, 'is-scroll': isScroll }">
    <div class="p-plan-table__title p-plan-table__title--has-btn">
      <div class="p-heading-area01__title">
        <h3 class="c-heading-2">
          <!-- TODO: ツールチップ -->
          <span class="c-text-with-tooltip">
            <span class="c-text-with-tooltip__text" [innerHTML]="'label.extraBaggage' | staticMsg"></span>
            <asw-tooltip
              id="plan-review-fbag-applied-tooltip"
              iconImage='<img src="assets/images/icon_help_primary_24.svg" alt="tooltip" width="20" height="20">'
              tooltipContent=""
              [tooltipTop]="0"
            ></asw-tooltip>
          </span>
        </h3>
      </div>
      <div class="p-heading-area01__sub-function">
        <asw-button
          id="plan-review-fbag-component-edit-btn"
          size="xs"
          [disabled]="!isPlanValid"
          [label]="'label.edit' | staticMsg"
          (click$)="openBaggageRequest()"
          [throttleClick]="true"
        ></asw-button>
      </div>
    </div>

    <div class="p-plan-table__contents">
      <asw-table-slider id="plan-review-fbag-slider" (isScrollChange)="setIsScroll($event)">
        <div class="p-plan-table__scroll">
          <div class="p-plan-table__scroll-view">
            <div class="p-plan-table__scroll-inner js-plan-table01-scroll" #detailPanel>
              <table class="c-plan-table01 js-plan-table01" #scrollPanel>
                <thead class="c-plan-table01__head">
                  <tr class="c-plan-table01__inner">
                    <td class="c-plan-table01__col" [ngClass]="{ 'grey-bg': !isPlanValid }">
                      <div class="c-plan-table01__col-inner"></div>
                    </td>
                    <ng-container *ngFor="let bound of data.bounds">
                      <th class="c-plan-table01__col" scope="col" [ngClass]="{ 'grey-bg': !isPlanValid }">
                        <div class="c-plan-table01__col-inner">
                          <div class="c-plan-table01__col-item c-plan-table01__col--em">
                            <span class="c-flight-info01__title-airport">
                              <span class="c-flight-info01__title-airport-departure">
                                {{ bound.departure }}
                                <span [innerHTML]="'label.hyphen' | staticMsg"></span>
                                {{ bound.arrival }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody class="c-plan-table01__body">
                  <ng-container *ngFor="let passenger of data.passengers">
                    <!-- ▼ 搭乗者氏名のみの行 ▼-->
                    <tr class="c-plan-table01__inner">
                      <th class="c-plan-table01__col" scope="row" [ngClass]="{ 'grey-bg': !isPlanValid }">
                        <div class="c-plan-table01__col-inner">
                          <div class="c-plan-table01__col-item c-plan-table01__col-item--em">
                            {{ passenger.name }}
                          </div>
                          <div
                            class="c-plan-table01__col-item c-plan-table01__col-item--gray60"
                            *ngIf="passenger.accompanyingName"
                          >
                            {{ passenger.accompanyingName }}
                          </div>
                        </div>
                      </th>
                      <ng-container *ngFor="let bound of passenger.boundInfo">
                        <td class="c-plan-table01__col" [ngClass]="{ 'grey-bg': !isPlanValid }">
                          <div class="c-plan-table01__col-inner"></div>
                        </td>
                      </ng-container>
                    </tr>
                    <!-- ▼ 事前追加手荷物用の行 ▼-->
                    <tr class="c-plan-table01__inner">
                      <th class="c-plan-table01__col" scope="row" [ngClass]="{ 'grey-bg': !isPlanValid }">
                        <div class="c-plan-table01__col-inner">
                          <div class="c-plan-table01__col-item" [innerHTML]="'label.extraBaggage' | staticMsg"></div>
                        </div>
                      </th>
                      <ng-container *ngFor="let bound of passenger.boundInfo">
                        <td class="c-plan-table01__col" [ngClass]="{ 'grey-bg': !isPlanValid }">
                          <div class="c-plan-table01__col-inner">
                            <div class="c-plan-table01__col-item">
                              <!-- 申込済みか否か -->
                              <ng-container
                                *ngTemplateOutlet="emphTr; context: { $implicit: bound.status }"
                              ></ng-container>
                              <!-- 金額 -->
                              <ng-container *ngIf="bound.status?.value === 'label.applied'">
                                <br />
                                <ng-container
                                  *ngTemplateOutlet="emphPrice; context: { $implicit: bound.price }"
                                ></ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </td>
                      </ng-container>
                    </tr>
                    <!-- ※特殊手荷物用の行は当画面には存在しない -->
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </asw-table-slider>
    </div>
  </div>
</div>
